/* ==========================================================================
   Gadea Loreak — Navegación (chrome del tema)
   --------------------------------------------------------------------------
   Sin dependencias. Se auto-inicializa una sola vez. Responsabilidades:
     · Header sticky   → añade .is-stuck a .iurop-header al hacer scroll.
     · Menú móvil      → abre/cierra el panel fullscreen #IuropMobileMenu.
     · Buscador móvil  → muestra/oculta #IuropMobileSearch (si no hay overlay
                         predictivo global #iurop-search, que lo gestionaría él).
     · Carrito         → [data-cart-open] abre el side-cart (#CartDrawer),
                         delegando en assets/iurop-cart.js (window.iuropCart /
                         evento 'cart:open').

   Contratos de marcado (sections/header.liquid + snippets/iurop-menu-mobile):
     .iurop-header                raíz del header (recibe .is-stuck / .is-menu-open)
     [data-menu-open]             abre/cierra el menú móvil
     #IuropMobileMenu             panel del menú móvil (.is-open)
     [data-menu-close] / overlay  cierran el menú
     [data-search-toggle]         muestra/oculta el buscador móvil
     #IuropMobileSearch           contenedor del buscador móvil (attr hidden)
     [data-cart-open]             abre el side-cart
   ========================================================================== */
(function () {
  'use strict';
  if (window.__iuropNavInit) return;
  window.__iuropNavInit = true;

  var doc = document;
  var html = doc.documentElement;

  function q(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function setExpanded(sel, val) {
    qa(sel).forEach(function (el) { el.setAttribute('aria-expanded', val ? 'true' : 'false'); });
  }
  function hasPredictiveSearch() { return !!doc.getElementById('iurop-search'); }

  var header, menu, mSearch;

  /* ---------- header sticky ---------- */
  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-stuck', window.scrollY > 6);
  }

  /* ---------- alto del chrome pegajoso ----------
     El sticky vive en el WRAPPER del section-group (anuncio + header). Publicamos
     su alto real en --iurop-header-h para que cualquier otra sección pueda
     colocarse justo debajo (p.ej. una fila de subcategorías sticky en la PLP)
     sin hardcodear un número que difiere entre móvil y escritorio. */
  function measureChrome() {
    // Alto de la barra de anuncios: el grupo sticky se desplaza hacia arriba esa
    // cantidad para que el anuncio se vaya con el scroll y quede solo el header.
    var ann = q('.iurop-ann');
    var annSection = ann && ann.closest ? ann.closest('.shopify-section') : null;
    var annH = annSection ? Math.round(annSection.getBoundingClientRect().height) : 0;
    html.style.setProperty('--iurop-ann-h', annH + 'px');

    // Alto del chrome que queda pegado (header + chips) para que otras secciones
    // puedan colocarse justo debajo sin hardcodear un número por viewport.
    var headerSection = header && header.closest ? header.closest('.shopify-section') : null;
    var h = headerSection ? Math.round(headerSection.getBoundingClientRect().height) : 0;
    if (h > 0) html.style.setProperty('--iurop-header-h', h + 'px');
  }

  /* ---------- bloqueo de scroll ---------- */
  function lockScroll() { html.classList.add('iurop-nav-locked'); }
  function unlockScroll() { if (!menuIsOpen()) html.classList.remove('iurop-nav-locked'); }

  /* ---------- menú móvil ---------- */
  function menuIsOpen() { return !!(menu && menu.classList.contains('is-open')); }

  function openMenu() {
    if (!menu || menuIsOpen()) return;
    // La tarjeta del menú se ALINEA con el panel flotante del header (mismo top,
    // mismos insets laterales) y baja desde ahí; el header (X/logo/buscar/carrito)
    // queda por encima formando su parte superior.
    var panel = header && header.querySelector('.iurop-header__panel');
    if (panel) {
      var r = panel.getBoundingClientRect();
      menu.style.setProperty('--iurop-menu-top', Math.max(8, Math.round(r.top)) + 'px');
      menu.style.setProperty('--iurop-menu-side', Math.max(10, Math.round(r.left)) + 'px');
      menu.style.setProperty('--iurop-menu-pad', Math.round(r.height + 16) + 'px');
    }
    menu.hidden = false;
    void menu.offsetWidth; // reflow para la transición
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    if (header) header.classList.add('is-menu-open');
    setExpanded('[data-menu-open]', true);
    lockScroll();
  }

  function closeMenu() {
    if (!menu || !menuIsOpen()) return;
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    if (header) header.classList.remove('is-menu-open');
    setExpanded('[data-menu-open]', false);
    unlockScroll();
    setTimeout(function () { if (!menuIsOpen()) menu.hidden = true; }, 340);
  }

  /* ---------- buscador móvil ---------- */
  function toggleSearch(force) {
    if (hasPredictiveSearch() || !mSearch) return; // lo gestiona iurop-search.js
    var willOpen = typeof force === 'boolean' ? force : mSearch.hidden;
    if (willOpen) {
      if (menuIsOpen()) closeMenu();
      mSearch.hidden = false;
      setExpanded('[data-search-toggle]', true);
      var input = q('input[type="search"]', mSearch);
      if (input) { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }
    } else {
      mSearch.hidden = true;
      setExpanded('[data-search-toggle]', false);
    }
  }

  /* ---------- carrito ---------- */
  function openCart() {
    if (menuIsOpen()) closeMenu();
    if (window.iuropCart && typeof window.iuropCart.open === 'function') {
      window.iuropCart.open();
    } else {
      doc.dispatchEvent(new CustomEvent('cart:open'));
    }
  }

  /* ---------- delegación de clicks ---------- */
  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-menu-open]')) { e.preventDefault(); menuIsOpen() ? closeMenu() : openMenu(); return; }
    if (t.closest('[data-menu-close]') || t.closest('[data-menu-overlay]')) { e.preventDefault(); closeMenu(); return; }

    if (t.closest('[data-search-toggle]')) {
      if (hasPredictiveSearch()) return; // no interferir con el overlay predictivo
      e.preventDefault(); toggleSearch(); return;
    }

    if (t.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }

    // navegar por un enlace del menú móvil lo cierra
    if (menuIsOpen() && t.closest('#IuropMobileMenu a[href]')) { closeMenu(); return; }
  }

  function onKeydown(e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (menuIsOpen()) closeMenu();
    else if (mSearch && !mSearch.hidden) toggleSearch(false);
  }

  /* ---------- init ---------- */
  function init() {
    header = q('.iurop-header');
    menu = doc.getElementById('IuropMobileMenu');
    mSearch = doc.getElementById('IuropMobileSearch');

    onScroll();
    measureChrome();
    window.addEventListener('load', measureChrome);
    window.addEventListener('resize', measureChrome);
    window.addEventListener('scroll', onScroll, { passive: true });
    doc.addEventListener('click', onClick);
    doc.addEventListener('keydown', onKeydown);

    // si algo (quick-add, etc.) abre el carrito, cerramos el menú para no taparlo
    ['cart:open', 'cart:added', 'cart-drawer:open'].forEach(function (ev) {
      doc.addEventListener(ev, function () { if (menuIsOpen()) closeMenu(); });
    });

    // al volver a desktop, cierra menú/buscador móvil
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 990) {
        if (menuIsOpen()) closeMenu();
        if (mSearch && !mSearch.hidden) toggleSearch(false);
      }
    });
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
})();
